import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { CalendarEvent } from "../../../Types/UnitFeatureTypes";


export interface FetchEventInfoState {
  request: {
      loading: boolean;
      error: string | null;
      singleEvent: CalendarEvent | null;
      data: CalendarEvent[] | null;
      count: string | null;
  };
}

export enum Types {
  FETCH_EVENT_REQUEST = "FETCH_EVENT_REQUEST",
  FETCH_EVENT_SUCCESS = "FETCH_EVENT_SUCCESS",
  FETCH_EVENT_FAILURE = "FETCH_EVENT_FAILURE",
}

const eventActions = createAsyncAction(
  Types.FETCH_EVENT_REQUEST,
  Types.FETCH_EVENT_SUCCESS,
  Types.FETCH_EVENT_FAILURE,
)
<
  { id?: string, start_date?: Date, end_date?: Date },
  { events?: CalendarEvent[], event?: CalendarEvent, count: string },
  { message: string }
>();

export const Actions = { eventActions };

export const initialState: FetchEventInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    singleEvent: null,
    data: null,
    count: '0'
  }
};

export type FetchEventState = typeof initialState;

const fetchEventRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.error = null;
    draft.request.data = null;

    return draft;
  });

const fetchEventSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.eventActions.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.data = payload.events ?? null;
    draft.request.singleEvent = payload.event ?? null;
    draft.request.count = payload.count;
    if (draft.request.data) {
      draft.request.loading = false;
    }

    return draft;
  });

const fetchAnnouncementFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.eventActions.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.eventActions.request, fetchEventRequest)
  .handleAction(Actions.eventActions.success, fetchEventSuccess)
  .handleAction(Actions.eventActions.failure, fetchAnnouncementFailure);
  